(function () {
	const LOGIN_SUBTITLE_TEXT = "Enter your credentials to continue.";
	const GUARDIAN_PATH = "/daycare-portal/guardian";
	const EDUCATOR_PATH = "/daycare-portal/login";
	const ADMIN_PATH = "/app";

	let currentMode = "admin";

	function ready(fn) {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", fn, { once: true });
			return;
		}
		fn();
	}

	function getSitePrefix() {
		const host = (window.location.hostname || "").toLowerCase();
		if (!host || host === "localhost" || host === "127.0.0.1" || host === "::1") {
			return "daycare";
		}
		const parts = host.split(".").filter(Boolean);
		if (parts[0] === "www" && parts[1]) {
			return parts[1];
		}
		return parts[0] || "daycare";
	}

	function getSiteName() {
		return getSitePrefix()
			.split(/[-_\s]+/)
			.filter(Boolean)
			.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
			.join(" ") || "Daycare";
	}

	function isLoginPage() {
		if (!document.querySelector("section.for-login, section.for-email-login, section.for-login-with-email-link")) {
			return false;
		}
		const path = window.location.pathname.replace(/\/+$/, "");
		return path === "" || path === "/" || path === "/login";
	}

	function getUrlMode() {
		const params = new URLSearchParams(window.location.search);
		const portal = (params.get("portal") || params.get("mode") || "").toLowerCase();
		const redirectTo = params.get("redirect-to") || "";
		if (portal === "guardian" || redirectTo.startsWith(GUARDIAN_PATH)) {
			return "guardian";
		}
		return "admin";
	}

	function setRedirectInput(value) {
		const form = document.querySelector("section.for-login form, section.for-email-login form");
		if (!form) {
			return;
		}
		let input = form.querySelector("input[name='redirect-to']");
		if (!input) {
			input = document.createElement("input");
			input.type = "hidden";
			input.name = "redirect-to";
			form.appendChild(input);
		}
		input.value = value;
	}

	function updateUrl(mode) {
		const url = new URL(window.location.href);
		url.pathname = "/login";
		url.search = "";
		if (mode === "guardian") {
			url.searchParams.set("portal", "guardian");
			url.searchParams.set("redirect-to", GUARDIAN_PATH);
		} else if (mode === "admin") {
			url.searchParams.set("portal", "admin");
			url.searchParams.set("redirect-to", ADMIN_PATH);
		}
		window.history.replaceState({}, "", url.pathname + url.search);
	}

	function applyMode(mode, options) {
		currentMode = mode === "guardian" ? "guardian" : "admin";
		document.body.dataset.daycareLoginCurrentMode = currentMode;

		const buttons = document.querySelectorAll(".daycare-login-choice[data-daycare-login-mode]");
		buttons.forEach((button) => {
			const active = button.dataset.daycareLoginMode === currentMode;
			button.classList.toggle("is-active", active);
			button.setAttribute("aria-pressed", active ? "true" : "false");
		});

		setRedirectInput(currentMode === "guardian" ? GUARDIAN_PATH : ADMIN_PATH);
		if (!options || options.updateUrl !== false) {
			updateUrl(currentMode);
		}
	}

	function setHeading() {
		const head = document.querySelector(
			"section.for-login .page-card-head, section.for-email-login .page-card-head, section.for-login-with-email-link .page-card-head"
		);
		if (!head) {
			return;
		}
		const title = head.querySelector("h4");
		if (title) {
			title.textContent = `Login to ${getSiteName()}`;
		}
		if (!head.querySelector(".daycare-login-prefix")) {
			const prefix = document.createElement("p");
			prefix.className = "daycare-login-prefix";
			prefix.textContent = LOGIN_SUBTITLE_TEXT;
			head.appendChild(prefix);
		}
	}

	function buildButton(mode, label) {
		const button = document.createElement("button");
		button.type = "button";
		button.className = "daycare-login-choice";
		button.dataset.daycareLoginMode = mode;
		button.setAttribute("aria-pressed", "false");
		button.textContent = label;
		if (mode === "educator") {
			button.addEventListener("click", () => {
				window.location.href = EDUCATOR_PATH;
			});
			return button;
		}
		button.addEventListener("click", () => applyMode(mode));
		return button;
	}

	function injectChooser() {
		const card = document.querySelector(
			"section.for-login .login-content.page-card, section.for-email-login .login-content.page-card"
		);
		if (!card || document.querySelector(".daycare-login-chooser")) {
			return;
		}
		const chooser = document.createElement("div");
		chooser.className = "daycare-login-chooser";
		chooser.setAttribute("aria-label", "Choose login type");
		chooser.append(
			buildButton("guardian", "I'm a Guardian"),
			buildButton("educator", "I'm an Educator"),
			buildButton("admin", "I'm an Administrator")
		);
		card.parentNode.insertBefore(chooser, card);
	}

	function bindSubmitGuard() {
		function syncRedirect() {
			setRedirectInput(currentMode === "guardian" ? GUARDIAN_PATH : ADMIN_PATH);
			updateUrl(currentMode);
		}

		document.addEventListener(
			"click",
			(event) => {
				const loginButton = event.target.closest(".btn-login, button[type='submit'], input[type='submit']");
				if (!loginButton || !loginButton.closest("section.for-login, section.for-email-login")) {
					return;
				}
				syncRedirect();
			},
			true
		);

		document.addEventListener(
			"submit",
			(event) => {
				if (!event.target.closest("section.for-login, section.for-email-login")) {
					return;
				}
				syncRedirect();
			},
			true
		);
	}

	function syncActiveSection() {
		const route = (window.location.hash.slice(1) || "login").replaceAll("-", "_");
		const allowedSections = ["login", "email", "forgot", "login_with_email_link", "signup"];
		document.body.dataset.daycareLoginSection = allowedSections.includes(route) ? route : "login";
	}

	function init() {
		if (!isLoginPage() || document.body.classList.contains("daycare-login-enhanced")) {
			return;
		}
		document.body.classList.add("daycare-login-enhanced");
		syncActiveSection();
		window.addEventListener("hashchange", syncActiveSection);
		document.addEventListener("login_rendered", syncActiveSection);
		setHeading();
		injectChooser();
		applyMode(getUrlMode(), { updateUrl: false });
		bindSubmitGuard();
	}

	ready(init);
})();
